import { handleActions } from 'redux-actions'
import {
  FETCH_RESUMES_DATA_INIT,
  FETCH_RESUMES_DATA_DONE,
  FETCH_RESUMES_DATA_FAIL,
} from '../actions/actions'

const resumesData = handleActions(
  {
    [FETCH_RESUMES_DATA_INIT]: (state, action) => {
      return {
        ...state,
        fetching: true
      }
    },
    [FETCH_RESUMES_DATA_DONE]: (state, action) => {
      const { data, total } = action.payload
      return {
        ...state,
        fetching: false,
        data,
        totalPageCount: Math.ceil(total/10)
      }
    },
    [FETCH_RESUMES_DATA_FAIL]: (state, action) => {
      return {
        ...state,
        fetching: false
      }
    },
  },
  {
    fetching: false,
    data: null,
    totalPageCount: 0
  }
)

export default resumesData
